/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Download: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V12.5861L8.70711 10.2932C8.31658 9.90272 7.68342 9.90272 7.29289 10.2932C6.90237 10.6838 6.90237 11.3169 7.29289 11.7075L11.2929 15.7075C11.4804 15.895 11.7348 16.0003 12 16.0003C12.2652 16.0003 12.5196 15.895 12.7071 15.7075L16.7071 11.7075C17.0976 11.3169 17.0976 10.6838 16.7071 10.2932C16.3166 9.90272 15.6834 9.90272 15.2929 10.2932L13 12.5861V4ZM6 16C6 15.4477 5.55228 15 5 15C4.44772 15 4 15.4477 4 16V18C4 19.6569 5.34315 21 7 21H17C18.6569 21 20 19.6569 20 18V16C20 15.4477 19.5523 15 19 15C18.4477 15 18 15.4477 18 16V18C18 18.5523 17.5523 19 17 19H7C6.44772 19 6 18.5523 6 18V16Z'
      fill='currentColor'
    />
  </React.Fragment>
)
